/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import { ContainerBox, Text } from '@jagex/design_runescape';
import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Container } from '@components/common/primitives';
import { LogoContainer } from '@components/layouts';

// TODO: think about caching translation key values for this page
const CommonErrorPage: FunctionComponent = () => (
  <>
    <Helmet>
      <title>Error - RuneScape | Old School RuneScape</title>
    </Helmet>
    <ContainerBox>
      <Container sx={{ textAlign: 'center' }}>
        <LogoContainer />
        <Text sx={{ mt: '1.25rem', mb: '0.5rem' }}>
          We are currently experiencing technical difficulties, please try again later.
        </Text>
      </Container>
    </ContainerBox>
  </>
);

export default CommonErrorPage;
